import { userSignOutSaga } from '../sagas/userSagas';
import { init as navigationInit } from './navigationComponent';
import addAccordionSupport from '../uiSupport/accordion';
import { init as accountInit } from './accountComponent';
import { init as searchInit } from './searchComponent';
import { init as enhancedSearchInit } from './enhancedSAYTComponent';
import { init as currencyInit } from './currencyComponent';
import { init as cartInit } from './cartComponent';
import { init as cartCountInit } from './cartCountComponent';
import { init as primaryHeaderPromoInit } from './primaryHeaderPromoComponent';
import { init as searchOverlayComponentInit } from './searchOverlayComponent';
import { init as countryInterstitialInit } from './countryInterstitialComponent';
import { handleUtagEvent, receiveCartItems } from '../actions/initialActions';

import {
    CLOSE_SITE_NAV,
    CLOSE_SITE_SEARCH,
    OPEN_SITE_NAV,
    OPEN_SITE_SEARCH,
    TOGGLE_SITE_NAV,
    TOGGLE_SITE_SEARCH,
    saytSearchResults,
    enhancedSaytSearchResults,
    toggleSiteNav,
    toggleSiteSearch
} from '../actions/headerActions';
import { userLoggedIn } from '../actions/initialActions';

import { debug } from '../utils/logger';
import { isIos8Safari } from '@core/js/utils/browserUtils';
import { generate, templateLocationExists } from '@core/js/utils/componentUtils';
import { getDefaultOptions } from '@core/js/utils/a15componentUtils';
import { attachPreventMobileOverScroll, detachPreventMobileOverScroll } from '@core/js/utils/eventUtils';

import { clearUniqueVisitsCookie } from '@core/js/utils/cookieUtils';

import {
    setupFixedHeader,
    isSiteMenuOpen,
    getSiteMenuHeight
} from '@core/js/utils/headerUtils';

import template from 'global-header.j2';

import { launchAsyncSignInModal } from '@core/js/utils/asyncLaunchers';

let originatingScrollOffset;

function toggleNavState(store, isTouchDevice, isSmallOrMediumDevice, shouldOpenNav) {
    if (shouldOpenNav === isSiteMenuOpen()) {
        return;
    }
    const headerPromo = $('.js-header-promo');
    const headerPromoDetails = $('.js-promo-details-content');

    /* Bind touch device mobile overscroll prevention */
    if (isTouchDevice) {
        if (shouldOpenNav) {
            $('.js-off-menu').scrollTop(1);
            originatingScrollOffset = $(window).scrollTop();
            attachPreventMobileOverScroll('touchstart.dom-main-navigation',
                'touchmove.dom-main-navigation', '.dom-main-navigation', '.js-off-menu');
        } else {
            detachPreventMobileOverScroll('touchstart.dom-main-navigation',
                'touchmove.dom-main-navigation', '.dom-main-navigation');

            /* Scroll back to original page position when closing nav */
            if (originatingScrollOffset) {
                $('html, body').scrollTop(originatingScrollOffset);
            }
        }
    }

    store.dispatch(toggleSiteNav(shouldOpenNav));
    $('.js-off-menu').height(shouldOpenNav ? getSiteMenuHeight() : '');
    $('html').removeClass('has-site-search-open')
             .toggleClass('has-site-menu-open', shouldOpenNav);

    if (isSmallOrMediumDevice) {
        if (headerPromo) {
            headerPromo.toggleClass('hide', shouldOpenNav);
        }

        if (headerPromoDetails) {
            headerPromoDetails.toggleClass('hide', shouldOpenNav);
        }
    }
}

function toggleSearchState(store, isSmallOrMediumDevice, isTouchDevice, shouldOpenSearch) {
    const headerPromo = $('.js-header-promo');
    const headerPromoDetails = $('.js-promo-details-content');
    const state = store.getState();
    const isEnhancedSaytEnabled = _.get(state, 'core.constants.enhancedSayt.enabled', false);

    store.dispatch(toggleSiteSearch(shouldOpenSearch));

    if (isEnhancedSaytEnabled) {
        store.dispatch(enhancedSaytSearchResults({}, [], 'header'));
    } else {
        store.dispatch(saytSearchResults([], [], 'header'));
    }

    $('.dom-site-search .js-site-search__input').val('');
    $('.js-off-menu').height('');

    if (isSmallOrMediumDevice) {
        if (headerPromo) {
            headerPromo.toggleClass('hide', shouldOpenSearch);
        }
        if (headerPromoDetails) {
            headerPromoDetails.toggleClass('hide', shouldOpenSearch);
        }
    }

    if (isTouchDevice && isSiteMenuOpen()) {
        detachPreventMobileOverScroll('touchstart.dom-main-navigation',
            'touchmove.dom-main-navigation', '.dom-main-navigation');
    }

    $('html').removeClass('has-site-menu-open')
             .toggleClass('has-site-search-open', shouldOpenSearch);
}

export function attachEvents(store) {
    const _this = this;

    const deviceCharacteristics = this.getDeviceCharacteristics();
    const isTouchDevice = _.get(deviceCharacteristics, 'is_touch', false);
    const isSmallOrMediumDevice = _.get(deviceCharacteristics, 'is_smallish', false) ||
        _.get(deviceCharacteristics, 'is_medium', false);

    // this is duped in loyaltyComponent.js for the sign in link while on PWA without Monoweb header
    // any changes made here should be reflected there
    $(document).on(this.scopedEvent('click'), '.js-signin', (e) => {
        if (this.external) {
            // Checkout will handle signin with their own modal
            return;
        }

        e.preventDefault();
        launchAsyncSignInModal(e, _this.name);

        // TODO move logic in a template so that a render
        // won't overwrite this change
        $('.js-site-wrap').attr('aria-hidden', 'true');
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-signout', (e) => {
        e.preventDefault();
        store.runSaga(userSignOutSaga);
        clearUniqueVisitsCookie();
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-promo-details-link', (e) => {
        const promoContent = $(e.target).closest('.js-global-promo')
                                        .next('.js-promo-details-content');
        const promoLink = $(e.target);

        e.preventDefault();
        $('.js-site-wrap').toggleClass('has-header-promo-details');
        promoContent.toggleClass('is-expanded');
        promoLink.attr('aria-expanded',
            promoLink.attr('aria-expanded') === 'false' ? 'true' : 'false'
        );
        promoContent.attr('aria-hidden',
            promoContent.attr('aria-hidden') === 'false' ? 'true' : 'false'
        );
    });

    $(window).resize(_.debounce(() => {
        if (!isSiteMenuOpen()) {
            return;
        }
        $('.js-off-menu').height(getSiteMenuHeight());
    }, 100));

    $(document).on(this.scopedEvent('touchend click'), '.js-site-menu-toggle', (e) => {
        e.preventDefault();
        $.event.trigger({
            type: TOGGLE_SITE_NAV
        });
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-cart-link', (e) => {
        if (this.isCart && isSiteMenuOpen()) {
            e.preventDefault();
            $.event.trigger({
                type: CLOSE_SITE_NAV
            });
        }
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-site-search-toggle', (e) => {
        e.preventDefault();
        $.event.trigger({
            type: TOGGLE_SITE_SEARCH
        });

        if (!isIos8Safari()) {
            $('.js-site-search-header-input')
                .focus()
                .trigger('touchend');
        }
    });

    $(document).on(TOGGLE_SITE_NAV, () => {
        const state = store.getState();
        const shouldOpenNav = !_.isUndefined(state.core.header.siteNav) ? !state.core.header.siteNav : true;

        toggleNavState(store, isTouchDevice, isSmallOrMediumDevice, shouldOpenNav);
    });

    $(document).on(OPEN_SITE_NAV, () => {
        toggleNavState(store, isTouchDevice, isSmallOrMediumDevice, true);
    });

    $(document).on(CLOSE_SITE_NAV, () => {
        toggleNavState(store, isTouchDevice, isSmallOrMediumDevice, false);
    });

    $(document).on(TOGGLE_SITE_SEARCH, () => {
        const state = store.getState();
        const shouldOpenSearch = !_.isUndefined(state.core.header.siteSearch) ? !state.core.header.siteSearch : true;

        toggleSearchState(store, isSmallOrMediumDevice, isTouchDevice, shouldOpenSearch);
    });

    $(document).on(OPEN_SITE_SEARCH, () => {
        toggleSearchState(store, isSmallOrMediumDevice, isTouchDevice, true);
    });

    $(document).on(CLOSE_SITE_SEARCH, () => {
        toggleSearchState(store, isSmallOrMediumDevice, isTouchDevice, false);
    });

    /* eslint-disable angular/document-service */
    document.addEventListener('a15-cart-header-bag-count-update', function bagCountUpdated(e) {
        const bagCount = _.get(e, 'detail.bagCount', -1);
        if (_.isInteger(bagCount) && bagCount >= 0) {
            const action = receiveCartItems({
                meta: {
                    totalQuantity: bagCount
                }
            });
            store.dispatch(action);
        }
    });

    document.addEventListener('a15-currency-toggle-hover', function currencyToggleHover() {
        const utagLinkData = {
            'event_category': 'top_nav',
            'event_action': 'Language',
            'event_label': ''
        };

        store.dispatch(handleUtagEvent(utagLinkData, 'link'));
        document.removeEventListener('a15-currency-toggle-hover', currencyToggleHover);
    });
    /* eslint-enable angular/document-service */

    document.addEventListener('a15-cart-header-destroy', function destroyCartHeader() {
        debug('eventListener: a15-cart-header-destroy');

        _this.destroyComponent(store);

        // reset core.loggedIn on destroy to bind the account dropdown event when component re-inits
        store.dispatch(userLoggedIn());
        document.removeEventListener('a15-cart-header-destroy', destroyCartHeader);
    });
}

function afterConstruction() {
    addAccordionSupport(this, `.dom-main-navigation${this.jsAccordionClass}`);
    setupFixedHeader(true);
}

function generateDictionary(state, dict, config) {
    const fixedHeaderClass = !_.get(state.core, 'siteDown') && !_.get(state.core, 'primaryHeaderPromo') ?
        'c-global-header-wrap--fixed' : '';

    const data = {
        fixedHeaderClass: fixedHeaderClass
    };

    return Object.assign({}, state, data);
}

export function onStateChange(store, watchValue, previous, current) {
    const state = store.getState();
    const isSmallOrMediumDevice = _.get(state, 'core.deviceCharacteristics.is_smallish', false) ||
                                  _.get(state, 'core.deviceCharacteristics.is_medium', false);

    if(watchValue === 'core.primaryHeaderPromo') {
        setupFixedHeader();
        return;
    }

    if(isSiteMenuOpen()) {

        if(isSmallOrMediumDevice) {
            $('.js-off-menu').height(getSiteMenuHeight());
            return;
        }
        $('html').removeClass('has-site-menu-open');
    }

    const dictionary = this.generateDictionary(store.getState());
    this.render(store, this, dictionary);
}

function searchComponentToAdd(state) {
    const useEnhancedSearch = _.get(state, 'core.constants.enhancedSayt.enabled', false);

    return useEnhancedSearch ? enhancedSearchInit : searchInit;
}

function destroyComponent(store) {
    this.removeAllChildren();
    this.removeEvents(store);
}

export function init(store, overrides = {}) {
    const config = {
        children: [
            navigationInit,
            [navigationInit, {
                templateLocation: '.dom-off-menu .dom-navigation-container'
            }],
            accountInit,
            [accountInit, {
                templateLocation: '.dom-off-menu .dom-utility-account'
            }],
            searchComponentToAdd(store.getState()),
            currencyInit,
            cartInit,
            cartCountInit,
            primaryHeaderPromoInit,
            countryInterstitialInit,
            searchOverlayComponentInit
        ],
        external: false,
        templateLocation: '.dom-header',
        isComponentValid: templateLocationExists,
        name: 'headerComponent',
        watch: ['core.deviceCharacteristics', 'core.primaryHeaderPromo'],
        attachEvents: attachEvents,
        afterConstruction: afterConstruction,
        afterRender: setupFixedHeader,
        jsAccordionClass: '.js-accordion',
        template: template,
        generateDictionary: generateDictionary,
        onStateChange: onStateChange,
        destroyComponent: destroyComponent
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
